import React from 'react';
import { compose, setPropTypes, pure } from 'recompose';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { withStyles } from '@material-ui/core/styles';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import MoreContentButton from '../atoms/MoreContentButton';
import DetailTextButton from '../atoms/DetailTextButton';
import ResetPassTextButton from '../atoms/ResetPassTextButton';
import DeleteUserTextButton from '../atoms/DeleteUserTextButton';
import QrCodeTextButton from '../atoms/QrCodeTextButton';

const styles = {
  firstTableCell: {
    borderRight: '1px solid #e0e0e0',
    padding: 10
  },
  overWrap: {
    whiteSpace: 'pre-line',
    width: '500px'
  }
};

const propTypes = {
  classes: PropTypes.object.isRequired,
  users: PropTypes.arrayOf(
    PropTypes.shape({
      userId: PropTypes.number,
      accountId: PropTypes.string,
      displayName: PropTypes.string,
      email: PropTypes.string,
      status: PropTypes.string,
      createdAt: PropTypes.string
    })
  ).isRequired
};

const enhance = compose(
  pure,
  setPropTypes(propTypes)
);

const UserTableBody = enhance(
  ({
    classes,
    users,
    emptyRows,
    page,
    rowsPerPage,
    messageViewAction,
    order,
    orderBy,
    detailOpenAction,
    resetPasswordAction,
    deleteAction,
    qrCodeAction
  }) => {
    let sortedResult;
    if (orderBy === 'gochiTotal') {
      sortedResult = _.orderBy(
        users,
        ['gochiCountTotal', 'gochiAmountTotal'],
        [order, order]
      );
    } else if (orderBy === 'useGochiTotal') {
      sortedResult = _.orderBy(
        users,
        ['useGochiCountTotal', 'useGochiAmountTotal'],
        [order, order]
      );
    } else {
      sortedResult = _.orderBy(users, orderBy, order);
    }
    return (
      <TableBody>
        {sortedResult
          .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
          .map(user => {
            const params = {
              id: user.userId
            };
            const paramsUserId = {
              userId: user.userId
            };
            const moreMessageLength = Number(
              process.env.REACT_APP_MORE_MESSAGE_LENGTH
            );
            return (
              <TableRow key={user.userId}>
                <TableCell>{user.userId}</TableCell>
                <TableCell>{user.accountId}</TableCell>
                <TableCell>{user.displayName}</TableCell>
                <TableCell>{user.email}</TableCell>
                <TableCell>{user.statusStr}</TableCell>
                <TableCell>
                  <div className={classes.overWrap}>
                    {/* メッセージの文字数が設定値を超えていれば、表示文字数制限 + moreアイコン */}
                    {user.message &&
                      user.message.length > moreMessageLength &&
                      user.message.substring(0, moreMessageLength)}
                    {user.message &&
                      user.message.length > moreMessageLength && (
                        <MoreContentButton
                          content={user.message}
                          onClickAction={messageViewAction}
                        />
                      )}
                    {/* メッセージの文字数が設定値以下であれば、そのまま表示 */}
                    {user.message &&
                      user.message.length <= moreMessageLength &&
                      user.message}
                  </div>
                </TableCell>
                {/* <TableCell>
                  {user.gochiCountTotal}
                  {' / '}
                  {user.gochiAmountTotal + user.gochiTaxAmountTotal}
                  {'（'}
                  {user.gochiAmountTotal}
                  {'）'}
                </TableCell>
                <TableCell>
                  {user.latestGochiDate != null && user.latestGochiDate}
                  {user.latestGochiDate == null && 'なし'}
                </TableCell>
                <TableCell>
                  {user.useGochiCountTotal}
                  {' / '}
                  {user.useGochiAmountTotal + user.useGochiTaxAmountTotal}
                  {'（'}
                  {user.useGochiAmountTotal}
                  {'）'}
                </TableCell>
                <TableCell>
                  {user.latestUseGochiDate != null && user.latestUseGochiDate}
                  {user.latestUseGochiDate == null && 'なし'}
                </TableCell> */}
                <TableCell>{user.createdAt}</TableCell>
                <TableCell>
                  <DetailTextButton
                    params={params}
                    onClickAction={detailOpenAction}
                  />
                </TableCell>
                <TableCell>
                  <QrCodeTextButton
                    id={user.userId}
                    name={user.displayName}
                    onClickAction={qrCodeAction}
                    textBtn="QRコード"
                    suffixes="GU"
                  />
                </TableCell>
                <TableCell>
                  <QrCodeTextButton
                    id={user.userId}
                    name={user.displayName}
                    onClickAction={qrCodeAction}
                    textBtn="QRコード"
                    suffixes="GC"
                  />
                </TableCell>
                <TableCell>
                  <ResetPassTextButton
                    params={paramsUserId}
                    onClickAction={resetPasswordAction}
                  />
                </TableCell>
                <TableCell>
                  <DeleteUserTextButton
                    id={params.id}
                    onClickAction={deleteAction}
                  />
                </TableCell>
              </TableRow>
            );
          })}
        {emptyRows > 0 && (
          <TableRow style={{ height: 49 * emptyRows }}>
            <TableCell colSpan={7} />
          </TableRow>
        )}
      </TableBody>
    );
  }
);

export default withStyles(styles)(UserTableBody);
